export default function ({ state, props }) {
    const parts = state.get('app.data.parts');

    const part = parts.find(p => p.slug === props.part);
    const section = part.sections.find(s => s.slug === props.section);

    if (section.isLast) {
        state.set('app.notification', part.notificationFinished);
    }

    return {
        isLast: section.isLast,
    };
}



// WEBPACK FOOTER //
// ./src/store/modules/app/actions/setEndNotification.js